<h2 mat-dialog-title>Alias User</h2>

<mat-dialog-content class="alias-picker-content">
  <p class="alias-picker-hint">
    Search for an active Professional Associate to view their portal in read-only guidance mode. Nothing can be changed while aliased.
  </p>

  <mat-form-field appearance="outline" class="alias-picker-search-field">
    <input
      matInput
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearchChange()"
      placeholder="Search by name, email, or organization"
      autocomplete="off"
    />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <p *ngIf="total > 0" class="alias-picker-count">
    {{ total }} active vendor{{ total === 1 ? '' : 's' }}
  </p>

  <div class="alias-picker-results">
    <div *ngIf="searching" class="alias-picker-status">
      <mat-spinner diameter="20"></mat-spinner>
      Searching…
    </div>

    <ul *ngIf="!searching && results.length" class="alias-picker-list">
      <li
        *ngFor="let vendor of results"
        class="alias-picker-list__item"
        [class.alias-picker-list__item--selected]="selected?.id === vendor.id"
        (click)="select(vendor)"
      >
        <span class="alias-picker-list__name">{{ vendor.name }}</span>
        <span class="alias-picker-list__meta"><ng-container *ngIf="vendor.org">{{ vendor.org }} &middot; </ng-container>{{ vendor.email }}</span>
      </li>
    </ul>

    <p *ngIf="!searching && searched && results.length === 0" class="alias-picker-status">
      No active vendors match that search.
    </p>
  </div>

  <mat-paginator
    *ngIf="total > 0"
    class="alias-picker-paginator"
    [length]="total"
    [pageSize]="pageSize"
    [pageIndex]="page"
    [pageSizeOptions]="[50]"
    [disabled]="searching"
    (page)="onPageChange($event)"
  >
  </mat-paginator>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button class="btn-cancel" type="button" (click)="cancel()" [disabled]="starting">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="confirm()" [disabled]="!selected || starting">
    {{ starting ? 'Starting…' : 'Start Session' }}
  </button>
</mat-dialog-actions>
